<template>
	<div v-if="loading">
		<div class="loader"></div>
	</div>
	<div v-else-if="Object.keys(team).length > 0" class="headed-table headed-table--sticky-labels">
		<table>
			<thead>
				<tr>
					<th>
						<small v-if="is_job" >Staff on Job</small>
                    	<small v-else >Staff in Company</small>
					</th>
					<th v-for="(header, index) in toolbox_talks_types" :key="index">
						<small>{{ header }}</small>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr  v-for="(user, rowIndex) in team" :key="rowIndex">
					<td>
                        <a :href="generateRouteUser(user.id)" class="people-list--item-title" target="_blank">
                            <h5 class="people-list--item-title-name">{{user.full_name}}</h5>
                            <h6 class="people-list--item-title-email">{{user.email}}</h6>
                        </a>
					</td>
					<td class="col-3" v-for="(cell, toolboxTalksIndex) in toolbox_talks_types" :key="toolboxTalksIndex">
						<div class="d-flex justify-content-center">
							<template v-for="(items) in user.toolboxTalks.hasTalks" >
								<div v-if="items.talk_id == toolboxTalksIndex" :key="items.form_submission_id">
                                    <a :href="generateRouteSubmission(items.job_id, items.form_submission_id)" target="_blank">
                                        <svg-image
                                            :src="'/svg/' + resource_group + '/certificate-pass.svg'"
                                            class="d-inline-flex"
                                            color="positive"
                                        />
                                    </a>
								</div>
							</template>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div v-else class="headed-table no-results d-flex justify-content-center">
		<div class="text-center">
			<h5 class="m-4 mx-auto text-dark">No staff assigned to job</h5>
		</div>
    </div>
</template>

<script>
    import generateRoute, { generateRouteWithMultipleParameters } from "../../helpers/routes";
	export default {
		name: "ToolboxTalksComponent",
		props: {
			loading:true,
			team:{},
			toolbox_talks_types:{},
            is_job: null,
            show_user_url: '',
            show_submission_url: '',
		},
        methods: {
            generateRouteSubmission(job, submission) {
                return generateRouteWithMultipleParameters(this._props.show_submission_url, {'job?': job, 'submission?': submission});
            },
            generateRouteUser(userId) {
                return generateRoute(this._props.show_user_url, userId);
            },
        }
	}
</script>

<style lang="scss" scoped>
.no-results {
	overflow-x: auto !important;
	overflow-y: auto !important;
}
.headed-table {
	overflow-x: scroll;
	overflow-y: scroll;
	max-height: 70vh;
	width:100%;
	border: 1px solid #f0f2f5;
	box-shadow:0.5px 1px 1px #CDD9E9;
		thead {
			position: sticky;
			top: -5px;
			border-radius: 10px;
			background-color: white;
			z-index: 100;
			th{
				border-top: none !important;
				min-width:8rem !important;
				justify-content: center;
				text-align: center;

			}
			th:first-child {
				justify-content: start;
				text-align: start;
			}
		}
	tr{
		min-width:8rem !important;
		justify-content: center;
		text-align: center;
		td{
			justify-content: center;
		}
		td:first-child {
			min-width: 18rem;
			justify-content: start;
			text-align: start;
		}
	}
}

</style>
